import { money, prettyDate } from "@/lib/api";
import { SampleBadge } from "@/components/site/SampleBadge";

export const PriceBreakdown = ({ quote }) => (
  <div data-testid="price-breakdown">
    <p className="text-sm text-muted-foreground" data-testid="breakdown-dates">{prettyDate(quote.check_in)} → {prettyDate(quote.check_out)} · {quote.guests} guest{quote.guests > 1 ? "s" : ""}</p>
    {quote.is_sample && <div className="mt-3"><SampleBadge className="!ml-0" /></div>}
    <dl className="mt-4 text-sm divide-y divide-border">
      {[...quote.lines, ...quote.taxes].map((l, i) => (
        <div key={i} className="flex justify-between py-2.5" data-testid={`breakdown-line-${i}`}><dt>{l.label}</dt><dd>{money(l.amount)}</dd></div>
      ))}
      <div className="flex justify-between py-3 font-semibold text-base"><dt>Total (USD)</dt><dd data-testid="breakdown-total">{money(quote.total)}</dd></div>
    </dl>
  </div>
);
